<template>
    <div ref="modal" class="modal fade add-product-modal-popup" tabindex="-1" role="dialog" :id="id">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                        aria-hidden="true">×</span>
                    </button>
                    <h4 class="modal-title p-0-30" id="modal-title"></h4>

                </div>
                <div class="modal-body">
                    <p>The recommended <b>price</b> for {{ this.service.service_name}}  service based on this quantity is <b>{{ this.currency.currency_symbol }}{{ this.getSuggestedPrice }}</b>. Do you wish to apply ? </p>
                </div>
                <div class="modal-footer">
                    <div id="navbarCollapse" class="navbar-collapse">
                        <button type="button" class="btn btn-primary-settings"  @click="cancelAction" >Keep current </button>
                        <button type="button" class="btn btn-danger" @click="submitAction">Apply recommended</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import {getServiceProducts} from "@/modules/Services/api/products";
import {EventBus} from "@/events/event-bus";

export default {
    name: "calculateServicePricingModal",
    props: {
        id: {
            required: true
        },
        service: {
            required: true,
            type: Object
        },
        currency: {
            required: true,
            type: Object
        },
        suggestedPrice: {
            required: true,
            type: Number
        },
        extraCharge: {
            required: true,
            type: Number
        },
        minimumCharge: {
            required: true
        }
    },
    data() {
        return {
            serviceProducts: [],
            selectedProducts: [],
            customProduct: true,
            searchValue: ''
        }
    },
    methods: {
        submitAction(event) {
            let valuesArr = {
                'price' : this.getSuggestedPrice,
                'extraCharge' : this.extraCharge,
            }
            EventBus.$emit('applyRecommended', valuesArr);


            $(this.$refs['modal']).modal('toggle')

            // load the end time popup
        },
        cancelAction(event) {
            $(this.$refs['modal']).modal('toggle')
        },
    },
    computed: {
        getSuggestedPrice() {
            if(this.minimumCharge){
                return Math.max(this.suggestedPrice, this.service.min_price)
            }
             return   this.suggestedPrice;
        },
    },
    mounted() {
if (typeof this.selectAutoAssignedProducts ==='function'){
    this.selectAutoAssignedProducts();
}


        getServiceProducts(this.service.service_id)
            .then(response => {
                if (response.data) {
                    this.serviceProducts = response.data
                }
            }),

        EventBus.$on('onSelectedProductDeleteConfirm', productId => {
            const index = this.selectedProducts.indexOf(productId);
            if (index > -1) {
                this.selectedProducts.splice(index, 1);
            }
        });


    }


}
</script>

<style scoped>

</style>